import { connect } from "react-redux";

import { arrayOf, bool, func, oneOf, string } from "prop-types";
import { deleteTasksAsThunk, bulkEditTasksAsThunk } from "../actions/thunks";

import withFilters from "../HOCs/withFilters";
import DeleteModal from "../../../../Tasks/components/DeleteModal";

const ModalDeleteTask = ({
  isTaskModalDeleteOpen,
  setTaskModalOpen,
  setTaskModalDelete,
  onDeleteTasksAsThunk,
  onBulkEditTasksAsThunk,
  ids,
  uuid,
  taskFilters,
  type,
}) => {
  const closeDeleteModal = () => {
    setTaskModalDelete((prev) => !prev);
    setTaskModalOpen?.((prev) => !prev);
  };

  const deleteTasks = () => {
    if (ids.length > 1) {
      onBulkEditTasksAsThunk(ids, uuid, taskFilters, { _destroy: true });
    } else {
      onDeleteTasksAsThunk(ids, uuid, taskFilters);
    }

    setTaskModalDelete((prev) => !prev);
  };

  return (
    <DeleteModal
      showDeleteModal={isTaskModalDeleteOpen}
      closeDeleteModal={closeDeleteModal}
      deleteTasksHandler={deleteTasks}
      type={type || (ids.length > 1 ? "Tasks" : "Task")}
    />
  );
};

ModalDeleteTask.propTypes = {
  isTaskModalDeleteOpen: bool,
  setTaskModalOpen: func,
  setTaskModalDelete: func,
  onDeleteTasksAsThunk: func,
  ids: arrayOf(string),
  uuid: string,
  taskFilters: string,
  onBulkEditTasksAsThunk: func,
  type: oneOf(["Task", "Tasks", "Appointment"]),
};

ModalDeleteTask.defaultProps = {
  isTaskModalDeleteOpen: false,
  setTaskModalOpen: null,
  setTaskModalDelete: null,
  onDeleteTasksAsThunk: null,
  ids: [],
  uuid: null,
  taskFilters: "",
  onBulkEditTasksAsThunk: null,
  type: null,
};

const mapStateToProps = (state) => ({
  uuid: state.tdpTasksReducer.uuid,
});

const mapDispatchToProps = (dispatch) => ({
  onBulkEditTasksAsThunk: (selectedTasks, listingUuid, filtered, payload) =>
    dispatch(bulkEditTasksAsThunk(selectedTasks, listingUuid, filtered, payload)),
  onDeleteTasksAsThunk: (ids, uuid, taskFilters) => dispatch(deleteTasksAsThunk(ids, uuid, taskFilters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withFilters(ModalDeleteTask));
